export const KIND_META = {
  load: { label: "Available Load", color: "#F2761E", filter: "Loads" },
  relief: { label: "Relief Driver Request", color: "#D7443E", filter: "Relief" },
  rv_rescue: { label: "RV Rescue", color: "#2E6FD9", filter: "RV Rescue" },
  rv_delivery: { label: "RV Delivery", color: "#7C4DFF", filter: "RV Delivery" },
};

export const FILTERS = ["Loads", "Relief", "RV Rescue", "RV Delivery"];

export const US_MARKERS = [
  { kind: "load", city: "Dallas, TX", lat: 32.7767, lng: -96.797 },
  { kind: "load", city: "Chicago, IL", lat: 41.8781, lng: -87.6298 },
  { kind: "load", city: "Oklahoma City, OK", lat: 35.4676, lng: -97.5164 },
  { kind: "relief", city: "Denver, CO", lat: 39.7392, lng: -104.9903 },
  { kind: "relief", city: "Atlanta, GA", lat: 33.749, lng: -84.388 },
  { kind: "rv_rescue", city: "Seattle, WA", lat: 47.6062, lng: -122.3321 },
  { kind: "rv_rescue", city: "Las Vegas, NV", lat: 36.1699, lng: -115.1398 },
  { kind: "rv_rescue", city: "Phoenix, AZ", lat: 33.4484, lng: -112.074 },
  { kind: "rv_rescue", city: "Kansas City, MO", lat: 39.0997, lng: -94.5786 },
  { kind: "rv_rescue", city: "Nashville, TN", lat: 36.1627, lng: -86.7816 },
  { kind: "rv_rescue", city: "Pittsburgh, PA", lat: 40.4406, lng: -79.9959 },
  { kind: "rv_delivery", city: "Minneapolis, MN", lat: 44.9778, lng: -93.265 },
  { kind: "rv_delivery", city: "Charlotte, NC", lat: 35.2271, lng: -80.8431 },
  { kind: "rv_delivery", city: "Columbus, OH", lat: 39.9612, lng: -82.9988 },
];

export const WORLD_MARKERS = [
  ...US_MARKERS,
  { kind: "load", city: "São Paulo, Brazil", lat: -23.5505, lng: -46.6333 },
  { kind: "load", city: "Toronto, Canada", lat: 43.6532, lng: -79.3832 },
  { kind: "relief", city: "Berlin, Germany", lat: 52.52, lng: 13.405 },
  { kind: "relief", city: "London, UK", lat: 51.5074, lng: -0.1278 },
  { kind: "rv_rescue", city: "Cape Town, South Africa", lat: -33.9249, lng: 18.4241 },
  { kind: "rv_rescue", city: "Mumbai, India", lat: 19.076, lng: 72.8777 },
  { kind: "rv_rescue", city: "Mexico City, Mexico", lat: 19.4326, lng: -99.1332 },
  { kind: "rv_delivery", city: "Sydney, Australia", lat: -33.8688, lng: 151.2093 },
];
